export default __webpack_public_path__ + "static/media/TableChange_Icon.8ee44cb5.svg";